<!--
  Painel da análise da prestação de contas (ADR-0010).
  Nenhum contador é somado aqui e nenhuma duração é calculada aqui: os números e o h:m:s
  chegam prontos do servidor, com a precisão de cada medição junto.
-->

<div class="col-md-12 no-padding">

  <ul class="nav nav-tabs" style="margin-bottom: 12px">
    <li [class.active]="aba === 'itens'">
      <a href="javascript:void(0)" (click)="trocarAba('itens')">
        <i class="fa fa-list-ol"></i> Itens e contadores
      </a>
    </li>
    <li [class.active]="aba === 'historico'">
      <a href="javascript:void(0)" (click)="trocarAba('historico')">
        <i class="fa fa-history"></i> Histórico do fluxo
      </a>
    </li>
    <li [class.active]="aba === 'checklist'">
      <a href="javascript:void(0)" (click)="trocarAba('checklist')">
        <i class="fa fa-check-square-o"></i> Checklist de documentos
      </a>
    </li>
  </ul>

  <div *ngIf="carregando" class="text-center" style="padding: 20px">
    <i class="fa fa-spinner fa-spin fa-2x"></i>
  </div>

  <!-- ============================================================ ITENS E CONTADORES -->
  <div *ngIf="aba === 'itens' && !carregando">

    <div class="row" *ngIf="contadores">
      <div class="col-md-2 col-sm-4">
        <div class="small-box bg-aqua">
          <div class="inner">
            <h3>{{ contadores.total }}</h3>
            <p>Total de itens</p>
          </div>
        </div>
      </div>
      <div class="col-md-2 col-sm-4">
        <div class="small-box bg-gray">
          <div class="inner">
            <h3>{{ contadores.naoVerificados }}</h3>
            <p>Não verificados</p>
          </div>
        </div>
      </div>
      <div class="col-md-2 col-sm-4">
        <div class="small-box bg-red">
          <div class="inner">
            <h3>{{ contadores.comPendencia }}</h3>
            <p>Com pendência</p>
          </div>
        </div>
      </div>
      <div class="col-md-2 col-sm-4">
        <div class="small-box bg-green">
          <div class="inner">
            <h3>{{ contadores.semPendencia }}</h3>
            <p>Sem pendência</p>
          </div>
        </div>
      </div>
      <div class="col-md-2 col-sm-4">
        <div class="small-box bg-blue">
          <div class="inner">
            <h3>{{ contadores.atualizadosAposCorrecao }}</h3>
            <p>Atualizados após correção</p>
          </div>
        </div>
      </div>
      <div class="col-md-2 col-sm-4" style="padding-top: 18px">
        <button class="btn btn-danger btn-sm btn-block" (click)="exportarPdf()">
          <i class="fa fa-file-pdf-o"></i> Extrato em PDF
        </button>
      </div>
    </div>

    <!-- Conferência exibida: as quatro situações têm de somar o total. -->
    <p class="text-muted" *ngIf="contadores">
      <i class="fa" [ngClass]="contadores.fecha ? 'fa-check text-green' : 'fa-warning text-red'"></i>
      Soma das situações: <strong>{{ contadores.somaDasSituacoes }}</strong>
      de <strong>{{ contadores.total }}</strong> itens.
      <span *ngIf="!contadores.fecha" class="text-red">
        As situações não somam o total — isso é defeito, não dado estranho.
      </span>
    </p>

    <div class="table-responsive">
      <table class="table table-bordered table-hover table-condensed">
        <thead>
          <tr>
            <th>Nº OB</th>
            <th>Tipo</th>
            <th class="text-right">Valor</th>
            <th>Transferência</th>
            <th>Situação</th>
            <th>Status gravado</th>
            <th class="text-center">Etapas</th>
            <th class="text-center">Fluxo</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of itens">
            <td>{{ item.numeroOb || '—' }}</td>
            <td>{{ item.tipo }}</td>
            <td class="text-right">{{ moeda(item.valor) }}</td>
            <td>{{ item.dataTransferencia | date: 'dd/MM/yyyy' }}</td>
            <td>
              <span [class]="classeDaSituacao(item)">{{ item.situacaoDescricao }}</span>
            </td>
            <!-- O texto cru separa "ninguém pediu" de "pediram e ninguém analisou". -->
            <td class="text-muted">{{ item.statusGravado || '—' }}</td>
            <td class="text-center">{{ item.analisesRegistradas }}</td>
            <td class="text-center">
              <button class="btn btn-xs btn-default" (click)="abrirHistorico(item)"
                      [disabled]="!item.analisesRegistradas">
                <i class="fa fa-history"></i> Ver
              </button>
            </td>
          </tr>
          <!--
            "Nao perguntei" e "perguntei e nao ha" nao sao a mesma frase (ADR-0074 §3.2).
            Esta tabela dizia "nao tem repasses" antes de a consulta sair da tela.
          -->
          <tr *ngIf="!itens">
            <td colspan="8" class="text-center text-muted">
              Nada consultado ainda.
            </td>
          </tr>
          <tr *ngIf="itens && !itens.length">
            <td colspan="8" class="text-center text-muted">
              Esta celebração não tem repasses a prestar contas.
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <p class="text-muted small">
      São contados os repasses (<code>Repasse</code> e <code>Repasse_final</code>). Extratos
      bancários, aplicações financeiras, INSS, FGTS, PIS, IR e devoluções de saldo não passam
      por análise e por isso não entram no contador.
    </p>
  </div>

  <!-- ============================================================ HISTÓRICO -->
  <div *ngIf="aba === 'historico' && !carregando">

    <div *ngIf="!itemDoHistorico" class="callout callout-info">
      Escolha um item na aba <strong>Itens e contadores</strong> e clique em
      <strong>Ver</strong> para abrir o fluxo de aprovação dele.
    </div>

    <div *ngIf="itemDoHistorico">
      <h4>
        Fluxo de aprovação — OB {{ itemDoHistorico.numeroOb || itemDoHistorico.id }}
        <small>{{ moeda(itemDoHistorico.valor) }}</small>
      </h4>

      <!-- A precisão é exibida, e não maquiada: o passado não tem hora. -->
      <div class="callout callout-warning" *ngIf="temEtapaSemHora">
        Algumas etapas foram gravadas antes de o sistema passar a guardar a hora da análise.
        Para elas, o decurso aparece <strong>em dias</strong>, e não em h:m:s — mostrar
        <code>00:00:00</code> ali diria "levou zero segundo", que não é verdade.
      </div>

      <div *ngFor="let tipo of tiposDoHistorico" style="margin-bottom: 18px">
        <h5><strong>{{ tipo }}</strong></h5>
        <table class="table table-bordered table-condensed">
          <thead>
            <tr>
              <th style="width: 50px">#</th>
              <th style="width: 150px">Quando</th>
              <th style="width: 110px">Decurso</th>
              <th>Status</th>
              <th>Responsável</th>
              <th>Observação</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let etapa of etapasDoTipo(tipo)">
              <td>{{ etapa.ordem }}</td>
              <td>{{ etapa.instante }}</td>
              <td>
                <span [title]="etapa.duracao?.explicacaoDaPrecisao">
                  {{ etapa.duracao?.formatada }}
                </span>
              </td>
              <td>
                <span [class]="etapa.pendencia ? 'label label-danger' : 'label label-success'">
                  {{ etapa.status }}
                </span>
              </td>
              <td>{{ etapa.usuarioNome || '—' }}</td>
              <td>{{ etapa.observacao || '—' }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <p class="text-muted small" *ngIf="etapas.length">
        O decurso de cada etapa é o tempo desde a etapa anterior <strong>do mesmo tipo de
        análise</strong>. Os cinco tipos correm em paralelo, e não em sequência.
      </p>
    </div>
  </div>

  <!-- ============================================================ CHECKLIST -->
  <div *ngIf="aba === 'checklist' && !carregando">

    <div class="row">
      <div class="col-md-4">
        <label>Fase</label>
        <select class="form-control input-sm" [(ngModel)]="faseEscolhida" (change)="trocarFase()">
          <option *ngFor="let fase of fases" [value]="fase.nome">{{ fase.descricao }}</option>
        </select>
      </div>
    </div>

    <div class="row" *ngIf="resumoChecklist" style="margin-top: 12px">
      <div class="col-md-12">
        <span class="label label-default">Exigidos: {{ resumoChecklist.total }}</span>
        <span class="label label-success">Entregues: {{ resumoChecklist.entregues }}</span>
        <span class="label label-warning">
          Pendentes de entrega: {{ resumoChecklist.pendentesDeEntrega }}
        </span>
        <span class="label label-danger">Vencidos: {{ resumoChecklist.vencidos }}</span>
        <span class="label label-warning">
          Vencem em {{ resumoChecklist.diasDeAlerta }} dias: {{ resumoChecklist.vencendoEmBreve }}
        </span>
        <span class="label label-warning">
          Sem validade informada: {{ resumoChecklist.semValidadeInformada }}
        </span>
      </div>
    </div>

    <div class="table-responsive" style="margin-top: 12px">
      <table class="table table-bordered table-hover table-condensed">
        <thead>
          <tr>
            <th>Documento</th>
            <th>Entrega</th>
            <th>Enviado em</th>
            <th>Validade</th>
            <th>Situação</th>
            <th>Observações</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of checklist">
            <td>
              {{ item.descricao }}
              <span *ngIf="item.exigeValidade" class="label label-default" title="Documento com prazo de validade">
                vence
              </span>
              <div class="text-muted small" *ngIf="item.recomendacao">{{ item.recomendacao }}</div>
            </td>
            <td>
              <span *ngIf="item.entregue" class="text-green">
                <i class="fa fa-paperclip"></i> {{ item.anexo || 'Entregue' }}
              </span>
              <span *ngIf="!item.entregue" class="text-muted">Não entregue</span>
            </td>
            <td>{{ item.dataEnvio || '—' }}</td>
            <td>
              {{ (item.dataValidade | date: 'dd/MM/yyyy') || '—' }}
              <span class="text-muted small" *ngIf="item.diasAteVencer !== null && item.diasAteVencer !== undefined">
                ({{ item.diasAteVencer }} dias)
              </span>
            </td>
            <td><span [class]="classeDaValidade(item)">{{ item.situacaoValidadeDescricao }}</span></td>
            <td>{{ item.observacoes || '—' }}</td>
          </tr>
          <tr *ngIf="checklist && !checklist.length">
            <td colspan="6" class="text-center text-muted">
              Nenhum documento cadastrado para esta fase.
              A lista de documentos exigidos é cadastro, não código — ela é mantida no cadastro
              de documentos do projeto.
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <p class="text-muted small">
      A lista sai completa mesmo sem nenhuma entrega: o checklist é o mesmo cadastro para todas
      as prestações, e não uma cópia por prestação. As entregas anteriores a esta versão
      aparecem sem data de envio, porque essa data nunca foi gravada.
    </p>
  </div>

</div>
